export const Constants = {
  
  Site: [
    { label: "Infosys", value: "Infosys" },
    { label: "TCS", value: "TCS" },
    { label: "Wipro", value: "Wipro" },
    { label: "Cognizant", value: "Cognizant" },
    
  ],
  Type: [
    { label: "large", value: "large" },
    { label: "small", value: "small" },
    { label: "medium", value: "medium" },
    { label: "enterprise", value: "enterprise" },
    
  ],

  Status: [
    { label: "In-Progress", value: "In-Progress" },
    { label: "Completed", value: "Completed" },
    
  ],

  Priority: [
    { label: "High", value: "High" },
    { label: "Medium", value: "Medium" },
    { label: "Low", value: "Low" },
    { label: "Critical", value: "Critical" },
    
  ],
};
    